import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Surf Guide & Blog — Raffiel Nias Surf Hotel, Sorake Beach";
    axios
      .get(`${API}/blog`)
      .then((res) => setPosts(res.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-sand-50 text-ink font-sans antialiased min-h-screen">
      <Navbar />
      <main>
        <section className="py-20 bg-sand-100 border-b border-sand-200" data-testid="blog-header">
          <div className="max-w-7xl mx-auto px-6">
            <span className="text-xs font-mono-clean text-terracotta uppercase tracking-wider font-semibold">
              Stories from Sorake Beach
            </span>
            <h1 className="font-display text-4xl sm:text-5xl font-bold text-ocean-900 mt-3">
              Nias Surf Guide & Hotel Blog
            </h1>
            <p className="text-sm text-fog mt-4 max-w-2xl leading-relaxed">
              Local knowledge from Lagundri Bay: swell seasons, board logistics,
              where to eat, and how to plan the perfect surf trip to South Nias.
            </p>
          </div>
        </section>

        <section className="py-16" data-testid="blog-list">
          <div className="max-w-7xl mx-auto px-6">
            {loading ? (
              <p className="text-sm text-fog">Loading stories...</p>
            ) : posts.length === 0 ? (
              <p className="text-sm text-fog">New stories are on the way — check back soon.</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {posts.map((p) => (
                  <Link
                    key={p.id}
                    to={`/blog/${p.slug}`}
                    data-testid={`blog-card-${p.slug}`}
                    className="bg-white rounded-2xl border border-sand-200 p-7 flex flex-col justify-between shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
                  >
                    <div>
                      {p.keyword && (
                        <span className="text-[11px] font-mono-clean uppercase tracking-wider text-terracotta font-semibold">
                          {p.keyword}
                        </span>
                      )}
                      <h2 className="font-display text-xl font-bold text-ocean-900 mt-2 leading-snug">
                        {p.title}
                      </h2>
                      <p className="text-xs text-fog leading-relaxed mt-3">{p.excerpt}</p>
                    </div>
                    <div className="mt-6 pt-4 border-t border-sand-200 flex items-center justify-between">
                      <span className="text-[11px] font-mono-clean text-fog">
                        {new Date(p.created_at).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })}
                      </span>
                      <span className="text-xs font-semibold text-ocean-700">Read story &rarr;</span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
